import * as React from 'react'
import { Container } from '@amzn/dvui/dist/Container'
import { withFatalCheck } from '../error/withFatalCheck'
import { tryCatch } from '../../utils/tryCatch'
import * as st from './schedule.module.scss'
import * as stUtility from '../utilityClasses.module.scss'
import { ScheduleItem } from './scheduleItem'
import { ICollection } from '../../selectors/collections'

export const ScheduleValid = tryCatch((props: ICollection) => {
  const { header, cardTitleIds, totalEpisodeSize, collectionType } = props
  if ((cardTitleIds || []).length === 0) {
    return null
  }
  return (
    <Container className={stUtility.pageSection}>
      {header && (
        <h1 className={st.header}>
          {' '}
          {header} ({totalEpisodeSize}){' '}
        </h1>
      )}
      <ol className={st.avScheduleList}>
        {cardTitleIds.map((titleId, idx) => (
          <React.Fragment key={idx}>
            <ScheduleItem idx={idx} key={idx} collectionType={collectionType} titleId={titleId} />
          </React.Fragment>
        ))}
      </ol>
    </Container>
  )
})

export const Schedule = withFatalCheck(ScheduleValid)
